module.exports = __webpack_public_path__ + "static/media/Thailand-tablet.9089bef2.jpg";